<template>
  <div class="descriptions-row">
    <div class="label">{{ label }}：</div>
    <div class="value"><slot></slot></div>
  </div>
</template>

<script>
export default {
  name: 'descriptions-item',
  props: {
    label: {
      type: String
    }
  }
};
</script>

<style lang="scss" scoped>
.descriptions-row {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 16px;
  width: 50%;

  .label {
    margin-right: 8px;
    font-size: 14px;
    color: rgb(89, 89, 89);
  }

  .value {
    flex: 1;
    font-size: 14px;
    line-height: 22px;
    color: #262626;
  }
}
</style>
